import { render, staticRenderFns } from "./ApprovalsTable.vue?vue&type=template&id=6e8a3ca0"
import script from "./ApprovalsTable.vue?vue&type=script&lang=js"
export * from "./ApprovalsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports